import React, { useState } from "react";
import PageInstructions from "@/components/PageInstructions";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import jsPDF from 'jspdf';

const Metodo777 = () => {
  const [premio, setPremio] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [calculationSteps, setCalculationSteps] = useState<string[]>([]);
  const [finalGroups, setFinalGroups] = useState<string[]>([]);
  const [finalBichos, setFinalBichos] = useState<string[]>([]);
  const [finalMilhares, setFinalMilhares] = useState<string[]>([]);

  const calcularMetodo777 = () => {
    const prizeNumber = parseInt(premio);
    
    if (!premio || prizeNumber < 1) {
      alert('Por favor, insira um número válido para o primeiro prêmio!');
      return;
    }

    // Extrair a centena (últimos 3 dígitos)
    const centena = parseInt(premio.toString().slice(-3));
    
    // Realizar as três multiplicações por 7
    const mult1 = centena * 7;
    const mult2 = mult1 * 7;
    const mult3 = parseInt(mult2.toString().slice(-3)) * 7; // Pega os últimos 3 dígitos de mult2
    
    // Extrair os grupos finais (centenas)
    const grupo1 = mult1.toString().slice(-3).padStart(3, '0');
    const grupo2 = mult2.toString().slice(-3).padStart(3, '0');
    const grupo3 = mult3.toString().slice(-3).padStart(3, '0');

    // Calcular grupos do bicho (1-25) baseados nas centenas
    // Regra: usar dois últimos dígitos. 00 = grupo 25 (Vaca). Fórmula: floor((dezena - 1) / 4) + 1
    const getGrupoFromCentena = (centena: string): number => {
      const dezena = parseInt(centena.slice(-2));
      if (dezena === 0) return 25;
      return Math.floor((dezena - 1) / 4) + 1;
    };

    const bicho1 = getGrupoFromCentena(grupo1);
    const bicho2 = getGrupoFromCentena(grupo2);
    const bicho3 = getGrupoFromCentena(grupo3);
    
    const nomesBichos = [
      '', 'Avestruz', 'Águia', 'Burro', 'Borboleta', 'Cachorro', 'Cabra', 'Carneiro',
      'Camelo', 'Cobra', 'Coelho', 'Cavalo', 'Elefante', 'Galo', 'Gato', 'Jacaré',
      'Leão', 'Macaco', 'Porco', 'Pavão', 'Peru', 'Touro', 'Tigre', 'Urso', 'Veado', 'Vaca'
    ];

    // Calcular milhares baseados nas multiplicações
    const milhar1 = mult1.toString().padStart(4, '0').slice(-4);
    const milhar2 = mult2.toString().padStart(4, '0').slice(-4);
    const milhar3 = mult3.toString().padStart(4, '0').slice(-4);

    // Preparar os passos do cálculo
    const steps = [
      `🔢 Centena extraída: ${centena}`,
      `1️⃣ ${centena} × 7 = ${mult1}`,
      `2️⃣ ${mult1} × 7 = ${mult2}`,
      `3️⃣ ${mult2.toString().slice(-3)} × 7 = ${mult3}`
    ];

    setCalculationSteps(steps);
    setFinalGroups([grupo1, grupo2, grupo3]);
    setFinalBichos([
      `${bicho1.toString().padStart(2, '0')} - ${nomesBichos[bicho1]}`,
      `${bicho2.toString().padStart(2, '0')} - ${nomesBichos[bicho2]}`,
      `${bicho3.toString().padStart(2, '0')} - ${nomesBichos[bicho3]}`
    ]);
    setFinalMilhares([milhar1, milhar2, milhar3]);
    setShowResults(true);
  };

  const exportData = () => {
    if (!showResults) {
      alert('⚠️ Primeiro calcule o método 777 para poder exportar!');
      return;
    }

    const doc = new jsPDF();
    const currentDate = new Date().toLocaleString('pt-BR');
    
    // Header
    doc.setFontSize(20);
    doc.text('Método 777 - Relatório', 20, 20);
    
    doc.setFontSize(12);
    doc.text(`Data de Exportação: ${currentDate}`, 20, 35);
    doc.text(`Primeiro Prêmio usado: ${premio}`, 20, 45);
    
    let yPos = 65;
    
    // Cálculos
    doc.setFontSize(14);
    doc.text('Cálculos realizados:', 20, yPos);
    yPos += 15;
    
    calculationSteps.forEach((step) => {
      doc.setFontSize(10);
      doc.text(step, 20, yPos);
      yPos += 10;
    });
    
    yPos += 20;
    
    // Centenas
    doc.setFontSize(14);
    doc.text('Centenas geradas:', 20, yPos);
    yPos += 15;
    
    doc.setFontSize(12);
    doc.text(finalGroups.join(', '), 20, yPos);
    yPos += 20;
    
    // Grupos do bicho
    doc.setFontSize(14);
    doc.text('Grupos do Bicho:', 20, yPos);
    yPos += 15;
    
    finalBichos.forEach((bicho) => {
      doc.setFontSize(10);
      doc.text(bicho, 20, yPos);
      yPos += 10;
    });
    
    yPos += 20;
    
    // Milhares
    doc.setFontSize(14);
    doc.text('Milhares sugeridos:', 20, yPos);
    yPos += 15;
    
    doc.setFontSize(12);
    doc.text(finalMilhares.join(', '), 20, yPos);
    
    doc.save(`metodo_777_${new Date().toISOString().split('T')[0]}.pdf`);
    alert('📤 PDF exportado com sucesso!');
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      calcularMetodo777();
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPremio(e.target.value);
    setShowResults(false);
  };

  return (
    <div className="w-full max-w-2xl mx-auto space-y-6">
      <PageInstructions
        title="📖 Como usar o Método 777"
        steps={[
          "Digite o resultado do 1º prêmio do último sorteio no campo abaixo",
          "Clique em 'Calcular Método 777' ou pressione Enter",
          "O sistema multiplica a centena por 7, três vezes consecutivas",
          "Veja as 3 centenas geradas, os grupos do bicho e os milhares sugeridos",
          "Use o botão 'Exportar PDF' para salvar os resultados"
        ]}
      />
      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          Método 777
        </h1>
        <p className="text-xl text-muted-foreground">Calculadora de Grupos para Loteria</p>
      </div>

      {/* Description */}
      <Card className="border-l-4 border-l-blue-500 bg-gradient-to-r from-slate-50 to-gray-50">
        <CardContent className="p-6">
          <p className="text-muted-foreground leading-relaxed">
            <strong className="text-slate-700">Como funciona:</strong> O Método 777 multiplica por 7 a centena do primeiro prêmio do último concurso, repetindo este processo três vezes consecutivas. Este método pode ajudar a identificar grupos, centenas e até milhares com maior probabilidade.
          </p>
        </CardContent>
      </Card>

      {/* Input Section */}
      <Card className="border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50">
        <CardContent className="p-6 space-y-6">
          <div className="space-y-3">
            <label className="block font-semibold text-slate-700 text-lg">
              Primeiro Prêmio do Último Concurso:
            </label>
            <input
              type="number"
              value={premio}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              placeholder="Ex: 1102"
              min="1"
              max="99999"
              className="w-full p-4 border-2 border-blue-300 rounded-xl text-center text-xl font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all duration-300"
            />
          </div>
          
          <Button
            onClick={calcularMetodo777}
            className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white py-4 text-lg font-bold rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-lg"
          >
            🎯 Calcular Método 777
          </Button>
        </CardContent>
      </Card>

      {/* Results */}
      {showResults && (
        <Card className="animate-in slide-in-from-bottom-4 duration-500">
          <CardContent className="p-0">
            <div className="bg-gradient-to-r from-pink-400 to-red-500 text-white p-6 rounded-t-lg">
              <div className="text-center space-y-4">
                <h3 className="text-2xl font-bold">📊 Cálculos do Método 777</h3>
                
                <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                  <div className="space-y-2 font-mono text-lg">
                    {calculationSteps.map((step, index) => (
                      <div key={index} className="text-left">
                        {step}
                      </div>
                    ))}
                  </div>
                </div>

                <h3 className="text-2xl font-bold mt-6">🎯 Centenas Geradas</h3>
                
                <div className="flex justify-center gap-4 flex-wrap mt-4">
                  {finalGroups.map((group, index) => (
                    <div
                      key={index}
                      className="bg-white text-purple-600 px-6 py-4 rounded-full text-2xl font-bold min-w-20 text-center shadow-lg hover:scale-110 transition-transform duration-300"
                    >
                      {group}
                    </div>
                  ))}
                </div>

                <h3 className="text-2xl font-bold mt-6">🐾 Grupos do Bicho</h3>
                
                <div className="flex justify-center gap-4 flex-wrap mt-4">
                  {finalBichos.map((bicho, index) => (
                    <div
                      key={index}
                      className="bg-white text-green-600 px-4 py-3 rounded-xl text-lg font-bold text-center shadow-lg hover:scale-110 transition-transform duration-300"
                    >
                      {bicho}
                    </div>
                  ))}
                </div>

                <h3 className="text-2xl font-bold mt-6">🎲 Milhares Sugeridos</h3>
                
                <div className="flex justify-center gap-4 flex-wrap mt-4">
                  {finalMilhares.map((milhar, index) => (
                    <div
                      key={index}
                      className="bg-white text-blue-600 px-6 py-4 rounded-full text-2xl font-bold min-w-20 text-center shadow-lg hover:scale-110 transition-transform duration-300"
                    >
                      {milhar}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Export Button */}
      {showResults && (
        <Card className="border-2 border-green-200 bg-gradient-to-br from-green-50 to-emerald-50">
          <CardContent className="p-6 text-center">
            <Button
              onClick={exportData}
              className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-3 text-lg font-bold rounded-xl"
            >
              📤 Exportar PDF
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Example */}
      <Card className="border-l-4 border-l-cyan-500 bg-gradient-to-r from-cyan-50 to-blue-50">
        <CardHeader>
          <CardTitle className="text-cyan-600 flex items-center gap-2">
            💡 Exemplo de Uso:
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-muted-foreground leading-relaxed">
          <p>Se o primeiro prêmio foi <strong className="text-slate-700">1102</strong>, pegamos a centena <strong className="text-slate-700">102</strong>:</p>
          <div className="space-y-1 ml-4">
            <p>• 102 × 7 = <strong className="text-slate-700">714</strong></p>
            <p>• 714 × 7 = <strong className="text-slate-700">4998</strong> (pegamos 998)</p>
            <p>• 998 × 7 = <strong className="text-slate-700">6986</strong></p>
          </div>
          <p className="italic text-cyan-700 font-medium">
            Resultado: centenas 714, 998, 986 - grupos 04, 25, 22 (Borboleta, Vaca, Tigre) - milhares 0714, 4998, 6986!
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Metodo777;